import { CheckboxProps, Option, SelectProps } from "@bluframe/blublocks"
import prepareComponent from "@bluframe/grapple/prepareComponent"
import {
  AutosuggestProps,
  HomeVideoReviewSearchItem,
  NewsSearchItem,
  SocialsGeneratePost,
  SocialsPlatform,
  SocialsPlatformServiceName
} from "@bluframe/mightychroma-mightytool-frontend-types"
import { RefObject, useMemo, useRef, useState } from "react"

import GeneratePosts from "./GeneratePosts"

export interface Props {
  arePlatformsLoading: boolean
  generatedPosts?: Partial<
    Record<SocialsPlatformServiceName, SocialsGeneratePost>
  >
  homeVideoReviewTitles: HomeVideoReviewSearchItem[]
  isAutosuggestLoading: boolean
  isGenerateDisabled: boolean
  isGenerateLoading: boolean
  newsTitles: NewsSearchItem[]
  onGetHomeVideoReviewsSuggestions: AutosuggestProps["onGetSuggestions"]
  onGetNewsSuggestions: AutosuggestProps["onGetSuggestions"]
  onClearAllClick: () => void

  onClearClick: (platform: SocialsPlatformServiceName) => () => void

  onGenerateAllClick: (additionalInstructions?: string) => void

  onGenerateClick: (platform: SocialsPlatformServiceName) => () => void

  onSelectHomeVideoReviewId: (id: string, name: string) => void

  onSelectNewsId: (id: string, name: string) => void
  platformsCheckboxes: CheckboxProps[]
  selectedHomeVideoReviewId: string
  selectedNewsId: string
  socialsPlatforms: SocialsPlatform[]
}

type SelectedType = "homeVideoReviews" | "news"

const types: Option[] = [
  {
    label: "Home Video Reviews",
    value: "homeVideoReviews"
  },
  {
    label: "News",
    value: "news"
  }
]

export interface ComponentProps extends Omit<Props, "onGenerateAllClick"> {
  generatedPostsCounter: string
  onChangeType: SelectProps["onChange"]
  onGenerateAllClick: () => void
  selectedType?: SelectedType
  textAreaRef: RefObject<HTMLTextAreaElement | null>
  types: Option[]
}

const DEFAULT_GENERATED_POSTS_KEY = ""

const usePrepareComponent = (props: Props): ComponentProps => {
  const [selectedType, setSelectedType] = useState<SelectedType>()
  const generatedPostsCounter = useMemo(
    () =>
      props.generatedPosts
        ? JSON.stringify(props.generatedPosts)
        : DEFAULT_GENERATED_POSTS_KEY,
    [props.generatedPosts]
  )
  const textAreaRef = useRef<HTMLTextAreaElement>(null)

  const onChangeType: SelectProps["onChange"] = (type) => {
    if (type === "homeVideoReviews" || type === "news") {
      setSelectedType(type)
    }
  }

  const onGenerateAllClick = () => {
    props.onGenerateAllClick(
      textAreaRef.current?.value === "" ? undefined : textAreaRef.current?.value
    )
  }

  return {
    ...props,
    generatedPostsCounter,
    onChangeType,
    onGenerateAllClick,
    selectedType,
    textAreaRef,
    types
  }
}

export default prepareComponent<Props, ComponentProps>(usePrepareComponent)(
  GeneratePosts
)
